// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.SalesInformation_checkbox__2flug:not(.SalesInformation_isEdit__1zu8e) {\n  margin-left: 22px; }\n", ""]);
// Exports
exports.locals = {
	"checkbox": "SalesInformation_checkbox__2flug",
	"isEdit": "SalesInformation_isEdit__1zu8e"
};
module.exports = exports;
